import Board from './components/board';
import './components/style.css';
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <div className="App" id='main'>
        <Board></Board>
        <Analytics />
    </div>
  );
}

export default App;
